module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title2"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-preface002"
    }
  }, [_vm._v("FAMILY TREES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Genealogies"), _c('a', {
    attrs: {
      "id": "p18"
    }
  }), _vm._v(" of the Agiad and Eurypontid Dynasties")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "height": "650",
      "src": "images/Art_P18.jpg",
      "width": "424"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Eurypontid"), _c('a', {
    attrs: {
      "id": "p19"
    }
  }), _vm._v(" Kings of Sparta")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "height": "682",
      "src": "images/Art_P19.jpg",
      "width": "406"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("The"), _c('a', {
    attrs: {
      "id": "p20"
    }
  }), _vm._v(" Achaimenids")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "height": "331",
      "src": "images/Art_P20.jpg",
      "width": "369"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("The "), _c('a', {
    attrs: {
      "id": "p21"
    }
  }), _vm._v("Alkmaionidai")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "height": "187",
      "src": "images/Art_P21a.jpg",
      "width": "327"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("The Family of Miliades (Philaidai)")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "height": "99",
      "src": "images/Art_P21b.jpg",
      "width": "294"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d6c824","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface002.vue
// module id = 75
// module chunks = 0